export const LOGIN_TYPE_NO = 'no';
export const LOGIN_TYPE_LOGIN = 'login';

// 阿里云服务设置
export const ALI_CLOUD_DOMAIN_STATIC = process.env.VUE_APP_ALI_CLOUD_DOMAIN_STATIC;

// 埋点地址
export const BURYING_POINT = 'https://sypm-md.bdx.jiankangsn.com/ylsd.gif';

// 图片大小
export const IMAGE_SIZE = 10 * 1024 * 1024;

// 分页初始展示条数
export const PAGINATION_SIZE = 10;

// 各种时间设定
export const ALERT_TIME = 2 * 1000;
export const CHANGE_THROTTLE_TIME = 100;
export const INTERACTION_THROTTLE_TIME = 3 * 1000;
export const HEALTH_CARD_CODE_REFRESH_TIME = 40 * 1000; // 电子健康卡二维码刷新时间（40秒）
export const OUT_CARD_CODE_REFRESH_TIME = 3 * 60 * 1000; // 电子就诊卡二维码刷新时间（3分钟）

export const PLATFORM_TYPE_WECHAT_MINI = 'Nw6sjqeyBI'; // 微信小程序
export const PLATFORM_TYPE_ALIPAY_MINI = 'nQHh2zHN9c'; // 支付宝小程序
export const PLATFORM_TYPE_BAIDU_MINI = 'Zq9eIpbjoB'; // 百度小程序
export const PLATFORM_TYPE_WECHAT_H5 = '4'; // 微信公众号
export const PLATFORM_TYPE_ALIPAY_H5 = '3'; // 支付宝生活号
export const PLATFORM_TYPE_WECHAT_CITY = 'xnlruyK01m'; // 微信城市服务
export const PLATFORM_TYPE_ALIPAY_CITY = '3gdrKEwcj9'; // 支付宝城市服务
export const PLATFORM_TYPE_PC = 'nlv3E1yFrz'; // 官网预约

export const PLATFORM_ID_OFFLINE = 'c8b5110cd4c44189b15908eb29beba92'; // 单点医院-患者端
export const PLATFORM_ID_ONLINE = 'c374fd43607c44456069768faa27517d'; // 互联网医院独立产品-患者端
export const PLATFORM_ID_INTEGRATION = 'b1371036feb0407992b97f2d3e8c7252'; // 一体化-患者端
export const PLATFORM_ID_SMART = 'bacfd82c90c945b9aa8fdcd134a1d166'; // 便捷就医
export const PLATFORM_ID_PC = '48c78921b6cb4eb2bb20ae97b89181e6'; // 官网预约

export const PROJECT_TYPE_OFFLINE = 'zysGcAGN2P'; // 单点医院-患者端
export const PROJECT_TYPE_ONLINE = 'zpCILQNfqM'; // 互联网医院独立产品-患者端
export const PROJECT_TYPE_INTEGRATION = 'OuhFrOwdEN'; // 一体化-患者端
export const PROJECT_TYPE_SMART = '0AqMrB3b6y'; // 便捷就医
export const PROJECT_TYPE_PC = 'nlv3E1yFrz'; // 官网预约

export const REG_TYPE_ALIPAY = '1'; // 支付宝
export const REG_TYPE_WECHAT = '2'; // 微信
export const REG_TYPE_OTHER = '3'; // 其它
export const REG_TYPE_CCB = '4'; // 龙支付
export const REG_TYPE_ETONE = '5'; // 易通金服
export const REG_TYPE_UNION = '6'; // 银联
export const REG_TYPE_SDYKT = '7'; // 山东一卡通
export const REG_TYPE_UMS = '8'; // 银联全民付
export const REG_TYPE_ICBC = '9'; // 工商银行
export const REG_TYPE_BAIDU = '10'; // 百度
export const REG_TYPE_ICBCD = '11'; // 工商银行数字人民币
export const REG_TYPE_UPUP = '12'; // 银联统一支付平台
export const REG_TYPE_CMBP = '13'; // 交通银行惠民付
export const REG_TYPE_YUANQI1 = '14'; // 源启支付平台1
export const REG_TYPE_YUANQI2 = '15'; // 源启支付平台2
export const REG_TYPE_UPCMBP = '16'; // 银联交行惠民付
export const REG_TYPE_JN = '17'; // 金能信息科技
export const REG_TYPE_WN = '18'; // 卫宁
export const REG_TYPE_DW = '19'; // 地纬

// 支付扩展业务类别
export const PAY_BUSINESS_TYPE_CREATE_OUT_CARD = '1'; // 在线建档
export const PAY_BUSINESS_TYPE_OUT_RECHARGE = '2'; // 门诊充值
export const PAY_BUSINESS_TYPE_TODAY_REGISTER = '3'; // 今日挂号
export const PAY_BUSINESS_TYPE_PAYMENT = '4'; // 门诊缴费
export const PAY_BUSINESS_TYPE_APPOINTMENT = '5'; // 预约挂号
export const PAY_BUSINESS_TYPE_SIGN_IN = '6'; // 预约签到
export const PAY_BUSINESS_TYPE_IN_RECHARGE = '7'; // 住院充值
export const PAY_BUSINESS_TYPE_LEAVE_DISCHARGE = '8'; // 出院结算
export const PAY_BUSINESS_TYPE_IN_CASE_MAIL = '9'; // 病历邮寄（住院）
export const PAY_BUSINESS_TYPE_OUT_CASE_MAIL = '10'; // 病历邮寄（门诊）
export const PAY_BUSINESS_TYPE_PARKING_PAYMENT = '11'; // 停车缴费

// 医保支付渠道
export const MEDICAL_PAY_CHANNEL_WECHAT = 'wxyb'; // 微信
export const MEDICAL_PAY_CHANNEL_ALIPAY = 'aliyb'; // 支付宝

export const INITIAL_DOCTOR_PHOTO = ALI_CLOUD_DOMAIN_STATIC + '/default.jpg';

export const ONLINE_DEFAULT_AREA = 'DEFAULT_AREA'; // 互联网医院不区分院区传值；符合当前情况接口传值均使用此常量

// 医院 ID
export const HOSPITAL_ID_SDQL = '49b83c26-a256-4088-b8a8-af3027d83793'; // 山东大学齐鲁医院
export const HOSPITAL_ID_QFS = '80d7fbb4d6bf467eb6ba5e47391df18c'; // 山东省千佛山医院
export const HOSPITAL_ID_TZRM = '4b08780ed4e046af81d593630bb9fa8e'; // 滕州市中心人民医院
export const HOSPITAL_ID_YTLYZX = 'YTSLYZXYYebf46e089315001c7b5370b'; // 烟台市莱阳中心医院
export const HOSPITAL_ID_SLX = 'slxy3f7ed53d4c799c248321294b9f4e'; // 山东省第二人民医院
export const HOSPITAL_ID_EBH = 'slxyebh7d53d4c799c248321294b9f4e'; // 山东省耳鼻喉医院
export const HOSPITAL_ID_QDQL = 'qdqlc26a2564088b8a8af3027d83793'; // 山东大学齐鲁医院（青岛）
export const HOSPITAL_ID_SDSL = 'SDSL2015'; // 山东省立医院
export const HOSPITAL_ID_YTS = 'YTSYY8e5d46242e2996d6416215bc8af'; // 烟台山医院
export const HOSPITAL_ID_ETYY = 'qlet413011c34cfa911bc68b59aacf63'; // 济南市儿童医院
export const HOSPITAL_ID_QDSL = 'qdslc26a2564004ee48f2b4be323da8'; // 青岛市市立医院
export const HOSPITAL_ID_JNRM = 'c8ad630ed995424e8c3f21f843636d76'; // 济南市人民医院
export const HOSPITAL_ID_SZY = '77f82a60-5b88-4e79-a103-f7c38f25816b'; // 山东省中医院
export const HOSPITAL_ID_JNSJGYY = 'JNSJGYY2fae64173afab6d60e5cbcb8f'; // 济南市济钢医院
export const HOSPITAL_ID_BYFY = 'b909a19d04ee48f2b4be323d00dc8888'; // 滨州医学院附属医院
export const HOSPITAL_ID_LKRM = 'lkrmyy7702a54aa3ad6aa241087e9525'; // 龙口市人民医院
export const HOSPITAL_ID_LCRM = 'LCRMYY'; // 聊城市人民医院
export const HOSPITAL_ID_LCNK = 'lcnkyy0c98614b0fb190ad9aa8f2a4f4'; // 聊城市脑科医院
export const HOSPITAL_ID_SDSZ = 'f20642a7-6daa-4ed1-ae76-0dcff26eb3e9'; // 山东大学附属生殖医院
export const HOSPITAL_ID_TAZX = 'TAZX-8ab-89b8-4590-bf83-37737b3041a5'; // 泰安中心医院
export const HOSPITAL_ID_ZPRM = 'ZPSRMYYaca534c3187b8cdaeb3cd8968'; // 邹平市人民医院
export const HOSPITAL_ID_TAFY = 'fc8e5782114740c68b1fd6f8cfe986cf'; // 泰安市妇幼保健院
export const HOSPITAL_ID_JNFY = 'JNSFYBJY519a4d07ad53f3f6c062df1d'; // 济南市妇幼保健院
export const HOSPITAL_ID_ZZZY = 'ZZSZYYYa69cb4df49413c5e1963bde14'; // 枣庄市中医医院
export const HOSPITAL_ID_ZQEY = 'JNSZQQDERMYY4e00aaed79d015880d01'; // 章丘区明水社区卫生服务中心
export const HOSPITAL_ID_YHD = 'c821251a84bb44e1bc6ec798a9e8247b'; // 烟台毓璜顶医院
export const HOSPITAL_ID_JNYZ = '25de9052-9ba5-4fce-9f91-3cf79bf93700'; // 济宁市兖州区人民医院
export const HOSPITAL_ID_JNDYRM = 'JNDYRMYY17bf467eb6ba5e47391df18c'; // 济宁市第一人民医院
export const HOSPITAL_ID_YTLL = 'f0f2676fe7044619913042ba8766a6ef'; // 玲珑英诚医院
export const HOSPITAL_ID_DZSL = '9fe04dcc3ddf4e809c7858180d9d16dc'; // 德州市市立医院
export const HOSPITAL_ID_DZRM = 'DZSRMYY3b5d9451a9d7c55a1869b3272'; // 德州市人民医院
export const HOSPITAL_ID_ZZSZQ = 'zzszqyyb9530862a49d4a3a826672aa7'; // 枣庄市市中区人民医院
export const HOSPITAL_ID_WLZY = 'WLZYYYfnu6jrkibzsyench9iddgv2fyf'; // 五莲县中医医院
export const HOSPITAL_ID_ZBGX = '7cd4dd6bb9ac41b4965a8c60bf858f19'; // 淄博世博高新医院
export const HOSPITAL_ID_NYXDYRM = 'nyyy22d8f3094e678f171edd566d7cca'; // 宁阳县第一人民医院
export const HOSPITAL_ID_ZHQRM = 'zhrmyyea8c034f42af1998645fa3c72f'; // 滨州市第二人民医院
export const HOSPITAL_ID_NJXZ = 'njxzyy8ca65a4aa0acf0ae327ab9e033'; // 宁津县中医院
export const HOSPITAL_ID_YTSBH = 'YTSBHYY4e9cf48fe896ef618833e1cfe'; // 烟台市北海医院
export const HOSPITAL_ID_WCXRM = 'wcxrmyy2419d4191945af67e8f42aa11'; // 武城县人民医院
export const HOSPITAL_ID_JNSSZQRM = 'JNSSZQRMYY454ad78be1f6261ca17738'; // 济南市市中区人民医院
export const HOSPITAL_ID_WSRM = 'WSXYY018986346f28f21123f67e03ffe'; // 微山县人民医院
export const HOSPITAL_ID_NYXRM = 'NYXRMYY57c3b47f48b28fc1d67269e1f'; // 宁阳县人民医院
export const HOSPITAL_ID_SDSJSWSZX = 'SDSJSWSZX2c75bb8bc389dcb2b64c261'; // 山东省精神卫生中心
export const HOSPITAL_ID_DZSLCQRM = 'DZSLCQRMYY8f44a9a3bb5a7eb0599ff2'; // 德州市陵城区人民医院
export const HOSPITAL_ID_SDXK = 'SDxkyy9e8a60430cac1909ef1ff5e3a1'; // 山东省胸科医院
export const HOSPITAL_ID_JNSZQQDERMYY = 'JNSZQQDERMYY4e00aaed79d015880d01'; // 章丘第二人民医院
export const HOSPITAL_ID_HJTZYYY = 'HJTZYYYc9992424b9437b93b95bc05d5'; // 宏济堂中医医院
export const HOSPITAL_ID_WFFY = 'WFSFYBJY52af4f1096df8c57ee5a267c'; // 潍坊市妇幼保健院
export const HOSPITAL_ID_RZXZ = 'RZSXZBYY60f64d06aa58d4daa5fcc13b'; // 日照心脏病医院
export const HOSPITAL_ID_WDZG = 'SDSWDZGYYf144cc1906b44c30b228c43'; // 山东省文登整骨医院
export const HOSPITAL_ID_PLRM = 'PLRMYY85188541cd9b820d06b8f6d916'; // 烟台市蓬莱人民医院
export const HOSPITAL_ID_LKZY = 'LKSZYYY894ab4a129558a985d04e379d'; // 龙口市中医医院
export const HOSPITAL_ID_WDFY = 'WHSFYBJY85e248bbba20f261c48f9ec5'; // 威海市文登区妇幼保健院
export const HOSPITAL_ID_QDYK = 'QDYKYY78aaf44a70aef750d57a61906f'; // 青岛眼科医院
export const HOSPITAL_ID_JNLW = 'LWQRMYYa8c93493b971999fa64e96856'; // 济南市莱芜人民医院
export const HOSPITAL_ID_SDSZL = 'SDSZLYYb977d4f36b65857f9bc4547c0'; // 山东省肿瘤医院
export const HOSPITAL_ID_WHSLDSYY = 'WHSLDSYY3df640dc832d914bc888ac04'; // 威海市立第三医院
export const HOSPITAL_ID_SDSZY = 'SDSZF493f36f4000ad635ae67e9e669f'; // 山东省职防
export const HOSPITAL_ID_960 = '960f24b9e15e4d588343f00022e92211'; // 解放军联勤保障部队第九六〇医院
export const HOSPITAL_ID_JNGXDQ = 'JNGXDQYY7d6142ee802df9b9d50b8f5e'; // 济南高新东区医院
export const HOSPITAL_ID_YGRM = 'YGXRMYYfe51c4c11b61a9f638dce188b'; // 阳谷县人民医院
export const HOSPITAL_ID_ZBCG = 'ZBCGYYb0e9894535bc3be414984e9e19'; // 淄博昌国医院
export const HOSPITAL_ID_HZSL = 'HZSLYY95eef34fbe84cf24ca3b95fcc6'; // 菏泽市立医院
export const HOSPITAL_ID_ZCRM = 'ZCSRMYY3df374a37b662d22f2aa92505'; // 邹城市人民医院
export const HOSPITAL_ID_QDGW = 'QDSGGWSLCZX744139f8cf22f3bdb03b2'; // 青岛市公共卫生临床中心
export const HOSPITAL_ID_JNZY = 'JNSZYYY01f6d43398f0ecea660b26b67'; // 济南市中医医院
export const HOSPITAL_ID_SDFY = 'SDSFYBJYc2594744a3fc0b74c6dc0a37'; // 山东省妇幼保健院

// 功能 ID
// ----- START ----- 门诊功能 ----- START -----
export const FUNCTION_ID_ZXJD = '95ul4eucagwohka7t5bxky6munja7z2b'; // 在线建档
export const FUNCTION_ID_ZNDZ = 'jin9z6s01wrg5jmfjlyrqeh0xp4scapn'; // 智能导诊
export const FUNCTION_ID_GHYY = 'xouftnwb83wkhi2vgioyjqsa7ewnaah4'; // 预约挂号
export const FUNCTION_ID_HBGH = 'l5w3964ly6q4xgf44vjhjjidxqj31l4t'; // 候补挂号
export const FUNCTION_ID_JRGH = 'klr6jqzmwiu982sqtpk1iy3m4dle28t7'; // 今日挂号
export const FUNCTION_ID_YWZ = '7qsuywpjb8yl0odi7oiz7zt3xg4irnrh'; // 预问诊
export const FUNCTION_ID_ZXQD = 'v74k6emplnf2iwag8fk62pbz8pk8zlwq'; // 在线签到
export const FUNCTION_ID_HZXX = 'bkojmjzy25e3hjtvrsuyq9fkd3oeflmj'; // 候诊信息
export const FUNCTION_ID_MZJF = 'd9d4ve5chlpwn4vw72z67codkh51ehfh'; // 门诊缴费
export const FUNCTION_ID_MZCZ = '509vwhm7zcr366cjum5a8lv3uxd0od56'; // 门诊充值
export const FUNCTION_ID_YJYY = '9ts8c70sk0ltqojrw4an66vv9ko4t2ul'; // 医技预约
export const FUNCTION_ID_MZBG = 'w4s5vfpuguaqy6euwl53etjkpl48w3uj'; // 门诊报告
export const FUNCTION_ID_CFXX = 'd5ptp0u6qxkhsjd7zlpxb0y5x5p337xa'; // 处方信息
export const FUNCTION_ID_MZDZFP = 'so5nj1d49ch4y0wciust42clfdmj5zrw'; // 门诊电子发票
export const FUNCTION_ID_MZBLCX = 'jat9n7prg6vsug31h9afka4j4n916l63'; // 门诊病历查询
export const FUNCTION_ID_MZMYDDC = 'erfk0y2qsas6z9ixgyjnh2giy3jck27k'; // 门诊满意度调查
export const FUNCTION_ID_ZXGY = 'nuei86y8d82sm5p1gfco9tgs8drc42fk'; // 在线购药
export const FUNCTION_ID_TCFW = 'sllvvxyxrwig3lu7z0je92jrybpsb051'; // 停车服务
export const FUNCTION_ID_XSTK = '8wnvuhqetk1gbo1x8zi3ghsr5e8cacv1'; // 线上退款
export const FUNCTION_ID_ZYPS = 'jfhz4uzgit17wm08jfq7y14midz5fjkr'; // 中药配送
export const FUNCTION_ID_YPSMS = 'vkjf7253lwqkzak8yvsu4renfhpco7zh'; // 药品说明书
export const FUNCTION_ID_TJJF = 'z2o88syhlx54h71qnsylf6kn7r9v2px2'; // 体检缴费
export const FUNCTION_ID_GJMZ = 'gug76ovvf86zr63dkoyesued794sn20p'; // 国际门诊
export const FUNCTION_ID_DXKZHMZ = 'veo6yex81xwpmq7jugq9whhvtvqyjwgl'; // 多学科综合门诊
export const FUNCTION_ID_MZYJP = 'll38suodpjmp12eeseavintgtyr559xh'; // 门诊云胶片
export const FUNCTION_ID_CXPDCX = 'fcnr2w4tt36e6mnzdtqhq7eb60wm58a5'; // 抽血排队查询
export const FUNCTION_ID_MZFY = 'ixpoxyh8c7wdgk7ngibhuyrkn150trba'; // 门诊费用
export const FUNCTION_ID_BLBG = 't440h8oii7qvazg8t6mal18kidlfo2t9'; // 病理报告
// ----- END ----- 门诊功能 ----- END -----
// ----- START ----- 住院功能 ----- START -----
export const FUNCTION_ID_ZYRGL = '95yjajpm79ebkzkl09nsj1k8cfla07hz'; // 住院人管理
export const FUNCTION_ID_ZZRY = '4b4kalzh3du1dy93qeq4oiy8tfzo4uue'; // 自助入院
export const FUNCTION_ID_ZYCZ = '1me9upuo9ijq6ttyfbu0kr5f0rcghwj9'; // 住院充值
export const FUNCTION_ID_ZYRQD = '5cumwts2zq0rxdbfalm4ve7ly8ji6v2k'; // 住院日清单
export const FUNCTION_ID_ZYFY = '3a40lyf85ag29a7zp7zgv0tonwews18f'; // 住院费用
export const FUNCTION_ID_ZYBG = 'xred90wugtfcsnhjxd1tnd6rqqosq5xl'; // 住院报告
export const FUNCTION_ID_CYJS = 'io7v24qnnvt387bw5y0yvczkbracggq1'; // 出院结算
export const FUNCTION_ID_CYDY = 'qp4lexvkh933nigpuo33ucqh0zxuc3dw'; // 出院带药
export const FUNCTION_ID_ZYBLYJ = '44r28nlqg8ndbk3nobwm1g4va1vpouvc'; // 住院病历邮寄
export const FUNCTION_ID_ZYMYDDC = 'x3o7bmyqo4b5h162vo2yy9lv77051b5y'; // 住院满意度调查
export const FUNCTION_ID_ZYDZFP = 'z7ok4qgt92xpuleaz2cqzqxmlnrfnjrj'; // 住院电子发票
export const FUNCTION_ID_ZYYBJSD = 'i9mexckwlxltcy399mx44x38nbhef44n'; // 住院医保结算单
export const FUNCTION_ID_CYJL = 'fsbsq10rvm752frb0a9ckp6cp4br7tpc'; // 出院记录
export const FUNCTION_ID_BASY = 'bs8clgf79e3zxu8isrbid5yk2wuc4vxo'; // 病案首页
export const FUNCTION_ID_JRXXWH = 'jtbn5eblu9k5ylbvi392apvnbiyj5caq'; // 金融信息维护
export const FUNCTION_ID_ZYYJP = 'x4nqw10ljz86d3f4f4q614ewzyoet7d6'; // 住院云胶片
export const FUNCTION_ID_ZYBLCX = 'drdia2ire2e91kv5qo63np8d42hsmahe'; // 住院病历查询
export const FUNCTION_ID_SSCX = 'vcv0h14nwotuiy1qpaii9my82m0dsmpw'; // 手术查询
// ----- END ----- 住院功能 ----- END -----
// ----- START ----- 体检功能 ----- START -----
export const FUNCTION_ID_GRTJYY = 'px49lqh6fi53m6x0ivo6xtqxovxnqj5o'; // 个人体检预约
export const FUNCTION_ID_TTTJYY = 'jg48febrgq6g7kj15c7mqf27x75qgxtx'; // 团体体检预约
export const FUNCTION_ID_TJBG = '8pwrynz59o7qq718jie9r38g5w0zokor'; // 体检报告
export const FUNCTION_ID_TJYX = 'qg6z4pzi8cfpstswv0zoqw8msnqry823'; // 体检影像
export const FUNCTION_ID_VIPYY = 'o298nwlz94vwdf0m72e61qdf02v9vdjl'; // VIP 预约
export const FUNCTION_ID_PLYTY = 's93qsvdoitxi90ynb640g2814wu30qh8'; // 批量与团约
// ----- END ----- 体检功能 ----- END -----
// ----- START ----- 互联网医院功能 ----- START -----
export const FUNCTION_ID_PBZL = 'cvbgpd3mdn69k0rq4c6q4c9rhfpso6dx'; // 排班诊疗
export const FUNCTION_ID_SPHZL = '2ipsdjzjv5p902fxx2l1b2pvjvramcyp'; // 碎片化诊疗
export const FUNCTION_ID_PBZX = 'djvqlv0039jxoq738j1bfxturlu7pfe6'; // 排班咨询
export const FUNCTION_ID_SPHZX = '7zoqhvt48m9l3rz3xigjwfizy18tm1bm'; // 碎片化咨询
export const FUNCTION_ID_MBXF = 'lsy9a9siuplxwdnboxf54vuiynpoms25'; // 慢病续方
export const FUNCTION_ID_CFD = '101x1q400hftgax61pv94raxvqygnwxb'; // 处方单
export const FUNCTION_ID_JYD = 'oj84xkq8mzor06ckcai8ap4pba2r44tr'; // 检验单
export const FUNCTION_ID_JCD = 'igbma6wcai258f635hnhi7re0hzdjap0'; // 检查单
export const FUNCTION_ID_ZLD = 'j7hg01kgyken98k5fxhpk9mosmh38n2m'; // 治疗单
export const FUNCTION_ID_ZYP = 'jxhy0n8zfwjs28c338t7gm9gwanxk5ik'; // 住院票
export const FUNCTION_ID_CFMB = '2oiikfvfn64velnx590746dzffkigk4g'; // 处方模版
export const FUNCTION_ID_BLMB = '8t0tfc4kx7yje8qb9al62xi0ez821qff'; // 病历模板
export const FUNCTION_ID_ZHBD = '9g31k10zhhbjhj275gskktcc5fjrhgv5'; // 诊后报到
export const FUNCTION_ID_SFJH = 'ky97sihuxgf7fsewew59ntzx15gunes1'; // 随访计划
export const FUNCTION_ID_YCYL = 'osd6mvy72mg3riq4916z6kfv1as9w7fy'; // 远程医疗
export const FUNCTION_ID_ZXKF = 'cfxma54thb7qpqiwa8g05pt5t7ipb490'; // 在线客服
export const FUNCTION_ID_PJ = '4qou14a4waoyqh3petdodknaysuqlf41'; // 评价
// ----- END ----- 互联网医院功能 ----- END -----
// ----- START ----- 全程服务功能 ----- START -----
export const FUNCTION_ID_ZJJT = 'z0fd43ea0hmhwh370i6xiv612f8ha99o'; // 专家讲堂
export const FUNCTION_ID_YYZX = 'ylvriwxvzb3yfxi6kpst500vn1q4nbdq'; // 医院资讯
export const FUNCTION_ID_DZGL = 'wsar4gyab8uedm4kt6dhmorrk49xgbou'; // 地址管理
export const FUNCTION_ID_WJCX = 'en8i4f8f1yyifpun6nkf5xm86b1z66ox'; // 物价查询
export const FUNCTION_ID_KSJS = 'o51ovgzybdpfgwmdwipgpp2fx8xgiq8y'; // 科室介绍
export const FUNCTION_ID_KSFB = 'i2h6u3nb9upbpv5n5nsvy9abogbqq2yw'; // 科室分布
export const FUNCTION_ID_TSYJY = 'j39bwx9m89kxbb2eycu8ahx4sqv95up9'; // 投诉与建议
export const FUNCTION_ID_WTFK = 'qr17hgcnkcu4se78kmjwg9y3q033lqfw'; // 问题反馈
export const FUNCTION_ID_YNDH = '30njc7kxodui9vi05yyuye22pf2lk7hb'; // 院内导航
export const FUNCTION_ID_LM = 'lh3a1jf6kd16t8mm94t6glzt3w9a0ou4'; // 亮码
export const FUNCTION_ID_JKGJ = 'bwu9hy41ulvst1re05968mu28q3mcll0'; // 健康工具
export const FUNCTION_ID_LYFB = '75tbq31ojqq6pysqz35zxx31hk2abisv'; // 楼宇分布
export const FUNCTION_ID_YYJS = '4t1ykv1jbk7dfxec9kess7v42wv8saz4'; // 医院介绍
export const FUNCTION_ID_YSJS = 'gphkw4n1qzvg2jw5t64ugq4srhijmzwx'; // 医生介绍
export const FUNCTION_ID_LYDH = 'nt8ahn2fkavuchasz7ln3v63gtymayf9'; // 来院导航
export const FUNCTION_ID_JYZN = 'uwkickhh6gygxomk27j20kp3or3bwwr1'; // 就医指南
export const FUNCTION_ID_BJMYDDC = 'ek2fm42hql5stxwffj15bj79uq1zvw9c'; // 便捷满意度调查
// ----- END ----- 全程服务功能 ----- END -----
// ----- START ----- 个性化开发功能 ----- START -----
export const FUNCTION_ID_YXHZ = 'nkynyeerzn3xps3n5koa4aw89jqo03g1'; // 影像会诊
export const FUNCTION_ID_MBSHCX = 'd9ofgum7xnhoq6qlmdp9o39teq0ugkpv'; // 慢病审核查询
export const FUNCTION_ID_HSJCSQ = 'dxj066m1ftpwsswqhs22qhbkckfwzr4n'; // 核酸检测申请
export const FUNCTION_ID_HSBG = '1cwsblhkz234g59lksc4f27khqobldb2'; // 核酸报告
// ----- END ----- 个性化开发功能 ----- END -----
// ----- START ----- 便捷就医 ----- START -----
export const FUNCTION_ID_BD = 'umwantwxcp8pz9t26jhnyelydjftesq0'; // 报到
export const FUNCTION_ID_HZ = 'kd3vzrw95qrztydrrz6f5ko3p3uqg272'; // 候诊
export const FUNCTION_ID_JZ = 'qmnnhpa5ve05aododqlf2cxvv6kix3bb'; // 就诊
export const FUNCTION_ID_ZHFW = 'mv2q1qk20vux41u44twgcybm6u8pm8gi'; // 诊后服务
export const FUNCTION_ID_JY = 'i87vzcamddlaa70g5az3yu9ik7by7abq'; // 检验
export const FUNCTION_ID_JC = '4tdlgc0a5qnron34rglz69z31j8677eo'; // 检查
export const FUNCTION_ID_CF = 'znaz2u3rg07tjw52wzf3lo53jr7rwvvp'; // 处方
export const FUNCTION_ID_ZL = 'xyhhh6lc0qq6m2unadnwotdekr212ois'; // 治疗
// ----- END ----- 便捷就医 ----- END -----
export const MAIN_FUNCTION_ID = [FUNCTION_ID_BD, FUNCTION_ID_HZ, FUNCTION_ID_JZ, FUNCTION_ID_ZHFW]; // 主流程功能
export const SUB_FUNCTION_ID = [FUNCTION_ID_JY, FUNCTION_ID_JC, FUNCTION_ID_CF, FUNCTION_ID_ZL]; // 主流程功能下级功能
export const APPOINT_FUNCTION_ID = [FUNCTION_ID_BD, FUNCTION_ID_HZ]; // 展示预约挂号的主流程功能

export const FUNCTION_ID_JYJC = 'kdflq5htain5fjr4fb6sya56cxwg23cx'; // 检验/检查
export const FUNCTION_ID_JYJC_JCYY = '824ppk7ta5x67xqdbfblqumpjhznvtab'; // 检验/检查-检查预约
export const FUNCTION_ID_JYJC_JCQXYY = 'kcehhdruwt7kewyvt71komme0f5uzj8b'; // 检验/检查-检查取消预约
export const FUNCTION_ID_JYJC_JCZF = '7hm91b14c67yrv72cflaoa9ra5o565in'; // 检验/检查-检查支付
export const FUNCTION_ID_JYJC_JYZF = '8iu01ls1dx2kkl1pkqvk8fwd92bax3xe'; // 检验/检查-检验支付
export const FUNCTION_ID_JYJC_PDFXZ = 'c51s95ocqz7g67mw08u8b8mwn4mwo9cn'; // 检验/检查-PDF 下载

export const DICTIONARY_CODE_OCCUPATION = 'occupation'; // 就诊人职业
export const DICTIONARY_CODE_DISCHARGE_MODE = 'discharge_mode'; // 出院结算出院方式
export const DICTIONARY_CODE_ADMISSION_IDENTIFY = 'admission_identify'; // 自助入院病人身份
export const DICTIONARY_CODE_PHYSICAL_PACKAGE_USERS = 'physical_package_users'; // 体检套餐适用人群
export const DICTIONARY_CODE_PHYSICAL_PACKAGE_TYPE = 'physical_package_type'; // 体检套餐类型
export const DICTIONARY_CODE_CASE_MAIL_EXPRESS_COMPANY = 'case_mail_express_company'; // 病历邮寄快递公司
export const DICTIONARY_CODE_CASE_MAIL_MEDICAL_ADDRESS = 'case_mail_medical_address'; // 病历邮寄自提地址
export const DICTIONARY_CODE_CASE_MAIL_PROCESS_STATUS = 'case_mail_process_status'; // 病历邮寄审核状态
export const DICTIONARY_CODE_CASE_MAIL_PRINTING_TYPE = 'case_mail_printing_type'; // 病历邮寄文书类型
export const DICTIONARY_CODE_MARRIAGE = 'marriage'; // 婚姻
export const DICTIONARY_CODE_CONTACT_RELATIONSHIP = 'contact_relationship'; // 联系人关系
export const DICTIONARY_CODE_INSURANCE_FILE_CODE = 'insurance_file_code'; // 医保建档编码
export const DICTIONARY_CODE_NATIVEPLACE = 'nativeplace'; // 籍贯
export const DICTIONARY_CODE_DOCUMENT_TYPE = 'document_type'; // 证件类型
export const DICTIONARY_CODE_CALENDAR_TYPE = 'calendar_type'; // 日程大项
export const DICTIONARY_CODE_INQUIRY_STATUS = 'inquiry_status'; // 问诊状态
export const DICTIONARY_CODE_CHECK_EXAMINE_STATUS = 'check_examine_status'; // 检验检查状态
export const DICTIONARY_CODE_CHECK_IN_STATUS = 'check_in_status'; // 诊后报到记录状态
export const DICTIONARY_CODE_FOLLOW_UP_STATUS = 'follow_up_status'; // 随访计划执行状态
export const DICTIONARY_CODE_PRESCRIPTION_STATUS = 'prescription_status'; // 处方状态
export const DICTIONARY_CODE_GUIDE_TYPE = 'guide_type'; // 须知类型
export const DICTIONARY_CODE_NATION = 'nation'; // 民族
export const DICTIONARY_CODE_PAY_MODE = 'pay_mode'; // 支付方式
export const DICTIONARY_CODE_CREATE_FILE_MODE = 'create_file_mode'; // 在线建档方式
export const DICTIONARY_CODE_OUT_PAYMENT_TYPE = 'out_payment_type'; // 门诊缴费类型
export const DICTIONARY_CODE_QUEUE_TYPE = 'queue_type'; // 候诊类型
export const DICTIONARY_CODE_OUT_REPORT_TYPE = 'out_report_type'; // 门诊报告类型
export const DICTIONARY_CODE_IN_REPORT_TYPE = 'in_report_type'; // 住院报告类型
export const DICTIONARY_CODE_SIGN_IN_TYPE = 'sign_in_type'; // 在线签到类型
export const DICTIONARY_CODE_SHOW_CODE_TYPE = 'show_code_type'; // 亮码类型
export const DICTIONARY_CODE_JUMP_FUNC_TYPE = 'jump_func_type'; // 功能跳转类型
export const DICTIONARY_CODE_REG_TYPE = 'reg_type'; // 支付类型
export const DICTIONARY_CODE_PRICE_SEARCH_TYPE = 'price_search_type'; // 物价查询类型
export const DICTIONARY_CODE_SCHEDULE_NOON = 'schedule_noon'; // 排班午别
export const DICTIONARY_CODE_LANGUAGE = 'language'; // 语言

export const DICT_PAY_MODE_CARD = 'card'; // 支付方式-就诊卡支付
export const DICT_PAY_MODE_SELF = 'self'; // 支付方式-自费支付
export const DICT_PAY_MODE_CHS = 'chs'; // 支付方式-医保支付
export const DICT_PAY_MODE_BOCOM = 'bocom'; // 支付方式-惠民就医支付
export const DICT_SIGN_IN_TYPE_APPOINTMENT = '0'; // 在线签到类型-预约
export const DICT_SIGN_IN_TYPE_CHECK = '1'; // 在线签到类型-检查
export const DICT_SIGN_IN_TYPE_EXAMINE = '2'; // 在线签到类型-检验
export const DICT_SIGN_IN_TYPE_TREAT = '3'; // 在线签到类型-治疗
export const DICT_SHOW_CODE_TYPE_HEALTH = 'health'; // 亮码类型-电子健康卡
export const DICT_SHOW_CODE_TYPE_CARD = 'card'; // 亮码类型-电子就诊卡
export const DICT_SHOW_CODE_TYPE_CHS = 'chs'; // 亮码类型-医保电子凭证
export const DICT_JUMP_FUNC_TYPE_SELF = '0'; // 功能跳转类型-站内功能
export const DICT_JUMP_FUNC_TYPE_H5 = '1'; // 功能跳转类型-外部 H5
export const DICT_JUMP_FUNC_TYPE_MINI = '2'; // 功能跳转类型-外部小程序

export const FAMOUS_EXPERT_TREATMENT_SCHEDULEQUERY = 'SCHEDULEQUERY';
export const FAMOUS_EXPERT_TREATMENT_DEFAULT = 'DEFAULT';

// 院内卡 CLINIC-TYPE
export const OUT_CARD_CLINIC_TYPE = '1'; // 门诊卡
export const IN_CARD_CLINIC_TYPE = '2'; // 住院卡

// 门诊卡 or 住院卡是否过期
export const OVER_DUE_STATE = '1'; // 已过期
export const NOT_OVER_DUE_STATE = '0'; // 未过期

export const SERVICE_TYPE_RECHARGE = '0'; // 充值

export const NOTICE_TYPE_OUT_RECHARGE = '0'; // 门诊充值
export const NOTICE_TYPE_APPOINTMENT = '1'; // 预约挂号
export const NOTICE_TYPE_PAYMENT = '2'; // 门诊缴费 or 体检缴费
export const NOTICE_TYPE_IN_RECHARGE = '3'; // 住院充值
export const NOTICE_TYPE_OTHER = '4'; // 滨州医学院附属医院-停车缴费
export const NOTICE_TYPE_IN_CASE_MAIL_XYD = '6'; // 青岛市市立医院-病历邮寄-信雅达下单
export const NOTICE_TYPE_APPOINTMENT_SIGN = '8'; // 预约签到
export const NOTICE_TYPE_SINGLE_PERSONAL_PHYSICAL = '9'; // 山东省立医院-个人体检
export const NOTICE_TYPE_OUT_CASE_MAIL = '10'; // 门诊病历邮寄
export const NOTICE_TYPE_GRAPHIC_CONSULT = '11'; // 图文咨询
export const NOTICE_TYPE_ORDINARY_PHYSICAL = '12'; // 通用体检预约
export const NOTICE_TYPE_OTC = '13'; // OTC 购药
export const NOTICE_TYPE_SCAN = '14'; // 诊单扫码付
export const NOTICE_TYPE_POLY = '15'; // 核酸检测 or 青岛市市立医院-互联网医院-门诊缴费
export const NOTICE_TYPE_LEAVE_DISCHARGE = '16'; // 出院结算
export const NOTICE_TYPE_APPOINTMENT_XYD = '17'; // 青岛市市立医院-预约挂号-信雅达下单
export const NOTICE_TYPE_PARKING_PAYMENT = '18'; // 停车缴费
export const NOTICE_TYPE_CANDIDATE = '19'; // 候补挂号
export const NOTICE_TYPE_PRE_VISIT = '20'; // 预就诊
export const NOTICE_TYPE_IN_CASE_MAIL = 'BADY'; // 住院病历邮寄

// 住院服务各功能备注
export const IN_FUNCTION_RECHARGE_REMARK = 'in-recharge'; // 住院充值
export const IN_FUNCTION_PAYMENT_REMARK = 'in-payment'; // 住院费用
export const IN_FUNCTION_REPORT_REMARK = 'in-report'; // 住院报告
export const IN_FUNCTION_PAYMENT_DAY_REMARK = 'in-payment-day'; // 住院日清单
export const IN_FUNCTION_SELF_ADMISSION_REMARK = 'self-admission'; // 自助入院
export const IN_FUNCTION_LEAVE_DISCHARGE_REMARK = 'leave-discharge'; // 出院结算
export const IN_FUNCTION_CLOUD_FILM_REMARK = 'cloud-film'; // 门诊、住院云胶片
export const IN_FUNCTION_OVERALL_PLANNING_REMARK = 'overall-planning'; // 住院统筹单
export const IN_FUNCTION_ELECTRONIC_INVOICE_REMARK = 'electronic-invoice'; // 电子发票
export const IN_FUNCTION_MEDICAL_SETTLE_FORM_REMARK = 'medical-settle-form'; // 医保结算单
export const IN_FUNCTION_CASE_REMARK = 'case'; // 住院病历
export const IN_FUNCTION_DISCHARGE_MEDICINE = 'discharge-medicine'; // 出院带药

export const SCAN_URL_PREFIX_PAYMENT = '/hos/ui/scan/payment'; // 诊单扫码付

// 问诊类型-用于处理当前类型是否开通
export const OPEN_CONSULT_TW_TYPE = 'RECEIVE_IMAGE'; // 图文
export const OPEN_CONSULT_SP_TYPE = 'RECEIVE_VIDEO'; // 视频
export const OPEN_CONSULT_DH_TYPE = 'RECEIVE_PHONE'; // 电话

// 须知类文案类型
export const SECRETARY_TYPE_ROSTERING_TREATMENT = 'ROSTERING_TREATMENT'; // 排班诊疗须知
export const SECRETARY_TYPE_FRAGMENTATION_TREATMENT = 'FRAGMENTATION_TREATMENT'; // 碎片化诊疗须知
export const SECRETARY_TYPE_ROSTERING_CONSULT = 'ROSTERING_CONSULT'; // 排班咨询须知
export const SECRETARY_TYPE_ONLINE_CONSULTING = 'ONLINE_CONSULTING'; // 碎片化咨询须知
export const SECRETARY_TYPE_CHRONIC_DISEASE_MANAGEMENT = 'CHRONIC_DISEASE_MANAGEMENT'; // 慢病续方须知
export const SECRETARY_TYPE_AFTER_DIAG = 'AFTER_DIAG'; // 诊后报到须知
export const SECRETARY_TYPE_INDEX_UPGRADE_PROMPT_DOC = 'INDEX_UPGRADE_PROMPT_DOC'; // 医生端首页温馨提示
export const SECRETARY_TYPE_USER_SERVICE_DOC = 'USER_SERVICE_DOC'; // 医生端用户服务协议
export const SECRETARY_TYPE_USER_PRIVACY_DOC = 'USER_PRIVACY_DOC'; // 医生端隐私政策
export const SECRETARY_TYPE_LOG_OFF_PROTOCOL_DOC = 'LOG_OFF_PROTOCOL_DOC'; // 医生端用户注销协议
export const SECRETARY_TYPE_REMOTE_CONSULT_INFORMED_CONSENT_DOC = 'REMOTE_CONSULT_INFORMED_CONSENT_DOC'; // 医生端远程会诊知情同意书
export const SECRETARY_TYPE_REMOTE_CONSULT_NOTICE_DOC = 'REMOTE_CONSULT_NOTICE_DOC'; // 医生端远程会诊须知
export const SECRETARY_TYPE_USER_SERVICE_PAT = 'USER_SERVICE_PAT'; // 患者端用户服务协议
export const SECRETARY_TYPE_USER_PRIVACY_PAT = 'USER_PRIVACY_PAT'; // 患者端隐私政策
export const SECRETARY_TYPE_LOG_OFF_PROTOCOL_PAT = 'LOG_OFF_PROTOCOL_PAT'; // 患者端用户注销协议
export const SECRETARY_TYPE_APPOINTMENT_NOC = 'APPOINTMENT_NOC'; // 预约挂号须知
export const SECRETARY_TYPE_TODAY_REGISTER_NOC = 'TODAY_REGISTER_NOC'; // 今日挂号须知
export const SECRETARY_TYPE_APPOINTMENT_VISIT_NOTICE = 'APPOINTMENT_VISIT_NOTICE'; // 预约就诊须知
export const SECRETARY_TYPE_APPOINTMENT_MULTIPLE_NOC = 'APPOINTMENT_MULTIPLE_NOC'; // 多学科综合门诊须知
export const SECRETARY_TYPE_APPOINTMENT_INTERNET_NOC = 'APPOINTMENT_INTERNET_NOC'; // 国际门诊须知
export const SECRETARY_TYPE_INDEX_UPGRADE_PROMPT_PAT = 'INDEX_UPGRADE_PROMPT_PAT'; // 患者端首页温馨提示
export const SECRETARY_TYPE_OUT_CASE_MAIL_NOC = 'OUT_CASE_MAIL_NOC'; // 门诊病历邮寄须知
export const SECRETARY_TYPE_IN_CASE_MAIL_NOC = 'IN_CASE_MAIL_NOC'; // 住院病历邮寄须知
export const SECRETARY_TYPE_REFUND_NOC = 'REFUND_NOC'; // 线上退款须知
export const SECRETARY_TYPE_PERSONAL_PHYSICAL_PREFIX_NOC = 'PERSONAL_PHYSICAL_PREFIX_NOC'; // 个人体检检前须知
export const SECRETARY_TYPE_PERSONAL_PHYSICAL_PACKAGE_NOC = 'PERSONAL_PHYSICAL_PACKAGE_NOC'; // 个人体检套餐须知
export const SECRETARY_TYPE_PERSONAL_PHYSICAL_APPOINT_NOC = 'PERSONAL_PHYSICAL_APPOINT_NOC'; // 个人体检预约须知
export const SECRETARY_TYPE_TEAM_PHYSICAL_PREFIX_NOC = 'TEAM_PHYSICAL_PREFIX_NOC'; // 团体体检检前须知
export const SECRETARY_TYPE_MEDICINE_DECOCTION_NOC = 'MEDICINE_DECOCTION_NOC'; // 中药代煎须知
export const SECRETARY_TYPE_NUCLEIC_ACID_NOC = 'NUCLEIC_ACID_NOC'; // 核酸检测须知
export const SECRETARY_TYPE_ELECTROCARDIOGRAM_NOC = 'ELECTROCARDIOGRAM_NOC'; // 心电检查须知
export const SECRETARY_TYPE_INSPECT_NOC = 'INSPECT_NOC'; // 线上检验须知
export const SECRETARY_TYPE_ELECTRONIC_INVOICE_NOC = 'ELECTRONIC_INVOICE_NOC'; // 电子发票打印须知
export const SECRETARY_TYPE_CHECK_APPOINT_NOC = 'CHECK_APPOINT_NOC'; // 检查预约须知
export const SECRETARY_TYPE_CHECK_SUGGEST_NOC = 'CHECK_SUGGEST_NOC'; // 检查报告建议与解释
export const SECRETARY_TYPE_BUY_MEDICINE_NOC = 'BUY_MEDICINE_NOC'; // 在线购药须知
export const SECRETARY_TYPE_IMAGE_CONSULTATION_NOC = 'IMAGE_CONSULTATION_NOC'; // 影像会诊须知
export const SECRETARY_TYPE_APPOINTMENT_INTERNET_BULLETIN_NOC = 'APPOINTMENT_INTERNET_BULLETIN_NOC'; // 国际门诊公告
export const SECRETARY_TYPE_IN_RECHARGE_NOC = 'IN_RECHARGE_NOC'; // 住院充值须知
export const SECRETARY_TYPE_DISCHARGE_RECORD_NOC = 'DISCHARGE_RECORD_NOC'; // 出院记录须知
export const SECRETARY_TYPE_MTA_NOC = 'MTA_NOC'; // 医技预约须知

// 基础数据业务类型
export const BASIC_BUSINESS_OFFLINE_CKQBYS = '-1'; // 查看全部医生
export const BASIC_BUSINESS_OFFLINE_ZMZJH = '0'; // 知名专家号
export const BASIC_BUSINESS_OFFLINE_ZJH = '1'; // 专家号
export const BASIC_BUSINESS_OFFLINE_PTH = '2'; // 普通号
export const BASIC_BUSINESS_OFFLINE_TSMZ = '3'; // 特色门诊
export const BASIC_BUSINESS_OFFLINE_DXKZHMZ = '4'; // 多学科综合门诊
export const BASIC_BUSINESS_OFFLINE_JZH = '5'; // 急诊号
export const BASIC_BUSINESS_OFFLINE_BMH = '6'; // 便民号
export const BASIC_BUSINESS_OFFLINE_ZBMZ = '7'; // 专病门诊
export const BASIC_BUSINESS_OFFLINE_ZLYY = '10'; // 诊疗预约
export const BASIC_BUSINESS_OFFLINE_ZFMZ = '11'; // 省府门诊（中医科、推拿科）
export const BASIC_BUSINESS_OFFLINE_GJTXMZ = '13'; // 国际特需门诊
export const BASIC_BUSINESS_OFFLINE_GDYXB = '14'; // 高端医学部（VIP门诊）
export const BASIC_BUSINESS_OFFLINE_FJJDXKZHMZ = '15'; // 肺结节多学科综合门诊
export const BASIC_BUSINESS_OFFLINE_XHZLDXKZHMZ = '16'; // 消化肿瘤多学科综合门诊
export const BASIC_BUSINESS_OFFLINE_ZJTDYY = '17'; // 专家团队预约
export const BASIC_BUSINESS_OFFLINE_YXMZ = '18'; // 山东省医学影像学研究所
export const BASIC_BUSINESS_OFFLINE_SWMZ = '19'; // 省委门诊（口腔科、推拿科）
export const BASIC_BUSINESS_OFFLINE_YNHJBMZ = '20'; // 疑难罕见病门诊
export const BASIC_BUSINESS_OFFLINE_LHMZ = '21'; // 联合门诊
export const BASIC_BUSINESS_OFFLINE_ZKLMJZYY = '22'; // 专科联盟就诊预约
export const BASIC_BUSINESS_OFFLINE_SMJBTD = '23'; // 睡眠疾病团队
export const BASIC_BUSINESS_OFFLINE_TWZX = '24'; // 图文咨询
export const BASIC_BUSINESS_OFFLINE_SPZX = '25'; // 视频咨询
export const BASIC_BUSINESS_OFFLINE_DHZX = '26'; // 电话咨询
export const BASIC_BUSINESS_OFFLINE_SQMZYY = '27'; // 暑期门诊预约
export const BASIC_BUSINESS_ONLINE_PBZL = 'ROSTERING_TREATMENT'; // 排班诊疗
export const BASIC_BUSINESS_ONLINE_PBZX = 'ROSTERING_CONSULT'; // 排班咨询
export const BASIC_BUSINESS_ONLINE_SPHZL = 'FRAGMENTATION_TREATMENT'; // 碎片化诊疗
export const BASIC_BUSINESS_ONLINE_ZXZX = 'ONLINE_CONSULTING'; // 在线咨询
export const BASIC_BUSINESS_ONLINE_DXKHZ = 'MULTI_DISCIPLINARY'; // 多学科会诊
export const BASIC_BUSINESS_ONLINE_MBXF = 'CHRONIC_DISEASE_MANAGEMENT'; // 慢病续方

// 配置类型
export const CONFIG_TYPE_GLOBAL = 'GLOBAL'; // 全局
export const CONFIG_TYPE_APPOINTMENT = 'APPOINTMENT'; // 预约模块
export const CONFIG_TYPE_BUY_MEDICINE = 'BUY_MEDICINE'; // 在线购药模块
export const CONFIG_TYPE_CASE_MAIL = 'CASE_MAIL'; // 病历邮寄模块
export const CONFIG_TYPE_DEPARTMENT = 'DEPARTMENT'; // 科室模块
export const CONFIG_TYPE_LECTURE = 'LECTURE'; // 讲堂模块
export const CONFIG_TYPE_HOMEPAGE = 'HOMEPAGE'; // 首页模块
export const CONFIG_TYPE_HOSPITALIZED = 'HOSPITALIZED'; // 出入院模块
export const CONFIG_TYPE_LOGIN = 'LOGIN'; // 登录模块
export const CONFIG_TYPE_NUCLEIC_ACID = 'NUCLEIC_ACID'; // 核酸检测模块
export const CONFIG_TYPE_PATIENT = 'PATIENT'; // 就诊人模块
export const CONFIG_TYPE_PAYMENT = 'PAYMENT'; // 缴费模块
export const CONFIG_TYPE_PHYSICAL = 'PHYSICAL'; // 体检模块
export const CONFIG_TYPE_QUERY = 'QUERY'; // 查询模块
export const CONFIG_TYPE_RECHARGE = 'RECHARGE'; // 充值模块
export const CONFIG_TYPE_REFUND = 'REFUND'; // 退款模块
export const CONFIG_TYPE_SEARCH = 'SEARCH'; // 搜索模块

export const CONFIG_COMPARE = {
  'appointment': [CONFIG_TYPE_APPOINTMENT, CONFIG_TYPE_RECHARGE, CONFIG_TYPE_SEARCH],
  'case-mail': [CONFIG_TYPE_CASE_MAIL],
  'lecture': [CONFIG_TYPE_LECTURE],
  'hospitalized': [CONFIG_TYPE_HOSPITALIZED],
  'payment': [CONFIG_TYPE_PAYMENT],
  'physical': [CONFIG_TYPE_PHYSICAL],
  'query': [CONFIG_TYPE_QUERY],
  'recharge': [CONFIG_TYPE_RECHARGE],
  'refund': [CONFIG_TYPE_REFUND]
};

// 搜索功能搜索内容
export const SEARCH_TYPE_DOCTOR = 'doctor'; // 医生
export const SEARCH_TYPE_DEPART = 'dept'; // 科室
export const SEARCH_TYPE_ENTIRE = 'keyword'; // 全部

export const PROJECT_PATTERN_JXBM = 'trainingRegistration'; // 进修报名

// 上传文件业务类型
export const UPLOAD_TYPE_JZR = 'e63ce4462ee011f0a36132d053a4c274'; // 就诊人管理
export const UPLOAD_TYPE_DXKZHMZ_TP = 'e63ce49f2ee011f0a36132d053a4c274'; // 多学科综合门诊-图片
export const UPLOAD_TYPE_DXKZHMZ_SP = 'e63ce4b32ee011f0a36132d053a4c274'; // 多学科综合门诊-视频
export const UPLOAD_TYPE_DXKZHMZ_WJ = 'e63ce4c32ee011f0a36132d053a4c274'; // 多学科综合门诊-文件
export const UPLOAD_TYPE_ZXGY = 'e63ce4d22ee011f0a36132d053a4c274'; // 在线购药
export const UPLOAD_TYPE_WTFK = 'e63ce4e32ee011f0a36132d053a4c274'; // 问题反馈
export const UPLOAD_TYPE_BLYJ = 'e63ce4f12ee011f0a36132d053a4c274'; // 病历邮寄
export const UPLOAD_TYPE_WJDC = 'e63ce5012ee011f0a36132d053a4c274'; // 问卷调查
export const UPLOAD_TYPE_EBTJ = 'e63ce5102ee011f0a36132d053a4c274'; // 儿保体检
export const UPLOAD_TYPE_ZHCRY = 'e63ce5212ee011f0a36132d053a4c274'; // 智慧出入院

export default {
  ALI_CLOUD_DOMAIN_STATIC,
  ALERT_TIME,
  CHANGE_THROTTLE_TIME
};
